import { DeploymentStatus } from '@sonar-software/sonar-core';
import React from 'react';
import { Tag } from 'antd';
export const DeploymentStatusTag = ({ status }) => {
    if (!status) {
        return null;
    }
    const convertedStatus = DeploymentStatus[status];
    let color;
    switch (convertedStatus) {
        case DeploymentStatus.Deployed:
            color = 'green';
            break;
        case DeploymentStatus.InDevelopment:
            color = 'gold';
            break;
        default:
            return null;
    }
    return React.createElement(Tag, { color: color }, convertedStatus);
};
